<template>
    <div v-if=location class = "has-text-centered navbar-item">
        <BaseIcon 
            icon="locationMarker" 
            :size=iconSize
            :classNames="{'store-navigation-color': true}"/>
        <a id="location-header">{{this.location.address}}</a>
    </div>
</template>

<script>
import { LOCATION } from '@/stores/defs';
import {mapGetters} from "vuex";
export default {
    props: {
        iconSize: {
            type: String,
            default: "1x"
        }
    },
    computed: {
        ...mapGetters({
            location: LOCATION.GET_LOCATION
        })
    }
}
</script>


<style lang="scss" scoped>
    @import 'globalStyles';

    #location-header{ 
        padding-left: 0.5em;
    }
</style>



// WEBPACK FOOTER //
// src/components/header/CurrentLocation.vue